import { update } from 'lodash'
import { CONFIG_URL } from '../helpers/constants'

const api = {
   URI_ENDPOINT: CONFIG_URL.SERVICE_URL,
   // Base URL cho các route v2 (thay /v1 cuối bằng /v2). Dùng cho webhook-config...
   URI_ENDPOINT_V2: (CONFIG_URL.SERVICE_URL || '').replace(/\/v1\/?$/, '/v2'),
   auth: {
      refreshToken: '/auth/refresh-tokens',
      login: '/auth/login',
      register: '/auth/register',
      getUserInfo: '/auth/getUserInfo',
      updateInfo: '/auth/updateInfo',
      changePassword: '/auth/changePassword',
      resetPassword: '/auth/reset-password',
      forgotPassword: '/auth/forgot-password',
      logout: '/auth/logout',
      verifyEmail: '/auth/verify-email',
      sendEmail: '/auth/send-verification-email'
   },
   twoFactor: {
      status: '/2fa/status',
      setup: '/2fa/setup',
      verifySetup: '/2fa/verify-setup',
      verifyLogin: '/2fa/verify-login',
      disable: '/2fa/disable'
   },
   user: {
      getProfile: '/profiles',
      updateProfile: '/profiles',
      changePassword: '/profiles/change-password',
      transaction: '/profiles/transaction',
      transactionProgress: '/profiles/transaction_progress',
      userTransaction: '/users/transaction'
   },
   upload: {
      uploadFile: '/upload'
   },
   productType: {
      getList: '/product-type',
      edit: '/product-type',
      create: '/product-type',
      delete: '/product-type'
   },
   tags: {
      getList: '/tags',
      edit: '/tags',
      create: '/tags',
      delete: '/tags'
   },
   designType: {
      getList: '/design-type',
      edit: '/design-type',
      create: '/design-type',
      delete: '/design-type'
   },

   products: {
      getList: '/products',
      edit: '/products',
      create: '/products',
      delete: '/products',
      previewImport: '/products/preview-import',
      multiCreate: '/products/create-multiple',
      exports: '/products/exports'
   },
   productGroup: {
      getGroups: '/product-groups',
      createGroups: '/product-groups',
      detailGroup: '/product-groups',
      exports: '/products/exports'
   },
   job: {
      getList: '/job',
      getDetail: '/job',
      lastJob: '/job/last-job',
      getFilterOption: '/listFilterOptions',
      receive: '/job/receive',
      reReceive: '/job/re-receive',
      review: '/job/review',
      designerUpdateUrl: '/job/designer-update',
      confirm: '/job/confirm',
      delete: '/job/delete',
      cancel: '/job/cancel',
      update: '/job/edit',
      count: '/job/count',
      rate: '/job/rate',
      isReceive: '/job/is-receive',
      total: '/job/total',
      sameNumber: '/job/sample-number',
      assignee: '/job/assignee',
      priority: '/job/priority',
      countCancel: 'job/count-cancel'
   },
   exchangeFee: {
      getList: '/exchange-fee',
      getFeeInfo: '/exchange-fee', //{{url}}/v1/exchange-fee?designTypeId=1&productTypeId=2
      edit: '/exchange-fee',
      create: '/exchange-fee',
      delete: '/exchange-fee'
   },
   prices: {
      getList: '/prices',
      reset: '/prices/reset',
      update: '/prices',
      create: '/prices',
      delete: '/prices',
      resetPriceUser: '/prices/resetPriceUser',
      updatePriceDefault: '/prices/updatePriceDefault',
      previewPrice: '/prices/preview-import',
      updateMultiple: '/prices/update-multiple'
   },
   activityHistory: {
      getList: '/history'
   },
   groupChat: {
      getList: '/chat',
      sendMessage: '/chat/message',
      getListMessage: '/chat/message'
   },
   managerUser: {
      getUser: '/users',
      create: '/users',
      update: '/users',
      delete: '/users',
      transaction: '/users/transaction'
   },
   config: {
      create: '/config',
      update: '/config',
      getList: '/config',
      getListSupport: '/config/get-link-support',
      configFF: '/config/ff'
   },
   debt: {
      getList: '/debts',
      total: 'debts/total'
   },
   funds: {
      create: '/funds',
      update: '/funds',
      approve: '/funds/approve',
      getList: '/funds',
      total: '/funds/total',
      status: '/funds/status'
   },
   notification: {
      get: '/notifications',
      getAll: '/notifications/all',
      update: '/notifications',
      mark_read: '/notifications/mark-read',
      send_to_user: '/notifications/send-to-user',
      send_to_role: '/notifications/send-to-role',
      unread_count: '/notifications/unread-count'
   },
   dashboard: {
      jobFinish: 'dashboard/job-finish',
      revenue: 'dashboard/revenue',
      inventoryAll: 'stores/inventoryAll'
   },
   draftOrder: {
      getList: '/draft-orders',
      update: '/draft-orders',
      create: '/draft-orders/create', //Ví dụ /draft-orders/create POST method để tạo mới draft order
      detail: '/draft-orders', //Ví dụ /orders/123 GET method để lấy detail của draft order có id là 123
      confirm: '/draft-orders/id/confirm', //Ví dụ: /draft-orders/123/confirm thế nên ở logic gọi API replace id bằng id của draft order
      delete: '/draft-orders', //ví dụ draft-orders/1 DELETE method
      confirmMulti: '/draft-orders/confirm',
      previewListOrder: '/draft-orders/import_preview',
      importListOrder: '/draft-orders/create_mul',
      calculatePrice: '/draft-orders/calculate-price'
   },
   order: {
      getList: '/orders',
      create: '/orders/create',
      cancel: '/orders/cancel',
      assignee: '/orders/assignee',
      confirm: '/orders/confirm',
      update: '/orders/update',
      updateStitches: '/orders/stitches',
      listStore: '/orders/listStore',
      detail: '/orders',
      finishOrder: '/orders/finishOrder',
      listStoreMultiOrder: '/orders/listStoreMultiOrder',
      exportExcel: '/orders/exportExcel',
      removeOrder: '/orders/remove',
      getShipingFee: '/orders/getShipingFee',
      refundOrder: '/orders/refund',
      pushOrder: '/orders/create_connect',
      getListHistory: '/orders/history',
      updateStatusFF: '/orders/updateStatusFF',
      updatesStatusFF: '/orders/updatesStatusFF',
      exportExcelv2: '/orders/export-excelv2',
      averageDeliveryTime: '/orders/averageDeliveryTime',
      previewListOrder: '/orders/import_preview',
      importListOrder: '/orders/create_mul',
      lineShipPrice: 'delivery/EP/line-ship-price',
      getTrackingVNE: 'orders/get-tracking-vne/'
   },
   service: {
      getList: '/services',
      getListAdmin: '/services/admin',
      create: '/services',
      update: '/services',
      delete: '/services'
   },
   orderv2: {
      getLabel: 'order/label'
   },
   stores: {
      getList: '/stores',
      create: '/stores/create',
      update: '/stores/update',
      productWithStoreMain: '/stores/productWithStoreMain',
      importExportList: '/stores/importExportList',
      importMainStore: '/stores/importMainStore',
      exportToFulfiment: '/stores/exportToFulfiment',
      listProductWithPromissory: '/stores/listProductWithPromissory',
      calculateInventory: '/stores/calculateInventory',
      productWithStore: '/stores/productWithStore',
      updateProductWithPromissory: '/stores/editPromissory'
   },
   sku: {
      getListProducts: '/productMaping'
   },
   delivery: {
      create: '/delivery/create',
      getPdf: '/delivery/getlabel',
      productMaping: 'productMaping/listProduct',
      webhook_FW_routing: 'delivery/webhook_FW_routing'
   },
   deliveryPartner: {
      getList: '/delivery-partners',
      create: '/delivery-partners/create',
      update: '/delivery-partners/update',
      delete: '/delivery-partners/delete'
   },
   tracking: {
      getList: 'tracking/list'
   },
   webhookWhitelist: {
      getList: '/webhook-whitelist',
      create: '/webhook-whitelist',
      update: '/webhook-whitelist',
      delete: '/webhook-whitelist'
   },
   // Cấu hình webhook outbound (v2). Mỗi account 1 URL, có thể bật/tắt.
   webhookConfig: {
      get: '/webhook-config',
      upsert: '/webhook-config',
      delete: '/webhook-config',
      test: '/webhook-config/test'
   }
}

export default api
